export const UPDATE_WORKOUT = 'updateWorkout';
export const UPDATE_PROGRAM = 'updateProgram';
export const UPDATE_CYCLE = 'updateCycle';
